// Identificador anônimo e persistente do visitante, usado para deduplicar
// curtidas por navegador (sem login). Guardado em localStorage via safeStorage
// (nunca lança). Se o armazenamento estiver indisponível, gera um id efêmero —
// a curtida ainda funciona na sessão, apenas não persiste entre visitas.

import { safeGet, safeSet } from "./safeStorage";

const VISITOR_KEY = "hl_visitor_id";

function randomId() {
    try {
        if (typeof crypto !== "undefined" && crypto.randomUUID) {
            return crypto.randomUUID();
        }
    } catch {
        // ignora — cai no fallback abaixo
    }
    return `v-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export function getVisitorId() {
    const existing = safeGet(VISITOR_KEY, { kind: "local" });
    if (existing) return existing;

    const fresh = randomId();
    safeSet(VISITOR_KEY, fresh, { kind: "local" });
    return fresh;
}
